export default function Footer() {
  return (
    <footer id="footer" className="w-full px-4 md:px-6 pt-14 pb-8 bg-background-900 text-background-200">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-base text-background-50"></i>
              </div>
              <span className="text-base font-semibold text-background-50 font-heading">天堂影视</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              天堂影视 —— 电影大全免费在线观看，高清蓝光画质不缓冲不卡顿，
              收录最新电影、高分电影，免广告畅享观影体验，每日更新电影资源。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '平台优势', href: '#features' },
                { label: '移动端观影', href: '#app' },
                { label: '影视花絮', href: '#media' },
                { label: '联系投稿', href: '#contact' },
                { label: '关于我们', href: '#about' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门专题</h4>
            <div className="flex flex-col gap-2">
              {['科幻电影合集', '悬疑推理片单', '华语电影天地', '日剧精选合集', '高分纪录片'].map((label) => (
                <span key={label} className="text-sm text-background-400 whitespace-nowrap cursor-pointer">
                  {label}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-background-500">更多合作伙伴即将入驻</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 天堂影视 ttys.com 版权所有。本平台所有内容仅供学习交流，请支持正版。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500">电影大全</span>
            <span className="text-xs text-background-500">免费在线观看</span>
            <span className="text-xs text-background-500">高清蓝光</span>
          </div>
        </div>
      </div>
    </footer>
  );
}